import { PreviewCart } from "../../components/cart/preview-cart";
import { ProductVariants } from "./product-variants";
import { PUB_SUB_EVENTS, publish } from "../../utils/pubsub";
class Product extends HTMLElement {
  constructor() {
    super();
    this.bindEvents();
  }

  bindEvents() {
    const enplHeadingEle = this.querySelector(".product__enpl-heading");
    enplHeadingEle?.addEventListener("click", this.toggleEnplSection.bind(this));

    const descriptionHeadingEle = this.querySelectorAll(".product__description-heading");
    descriptionHeadingEle.forEach((ele) => {
      ele.addEventListener("click", this.toggleDescription.bind(this));
    });

    const addToCartButton = this.querySelector("cta-cart");

    if (this.classList.contains("main-product-bundle")) {
      addToCartButton?.addEventListener("click", (event) => {
        this.addBundleProductsToCart(event);
      });
    } else {
      addToCartButton?.addEventListener("click", this.addProductToCart.bind(this));
    }

    const productVariantInputs = this.querySelectorAll(".product__swatches-group product-variants input");
    const productVariants = new ProductVariants();
    productVariantInputs.forEach((input) => {
      const variantId = input.getAttribute("data-id") as string;

      input.addEventListener("change", () => {
        productVariants.onVariantSelect(variantId, this);
      });
    });

    const description = this.querySelector(".product__short-des");
    if (description) {
      description.addEventListener("click", this.expandDetail.bind(this));
    }
  }

  toggleEnplSection(event: Event) {
    const showMoreEle = this.querySelector(".show-more");
    const showLessEle = this.querySelector(".show-less");
    showMoreEle?.classList.toggle("hide");
    showLessEle?.classList.toggle("hide");

    const target = event.currentTarget as HTMLElement;
    target?.parentElement?.classList.toggle("is-open");
  }

  toggleDescription(event: Event) {
    const target = event.currentTarget as HTMLElement;
    const parentEle = target?.parentElement;
    parentEle?.classList.toggle("active");
  }

  expandDetail(event: Event) {
    const target = event.currentTarget as HTMLElement;
    target.classList.add("expanded");
  }

  addBundleProductsToCart(event: any) {
    let productsArr: any = [];

    console.log("adding bundles")
    const bundleProducts = this.querySelectorAll(".product__bundle .product__bundle-product");
    const ctaButton = document.querySelector(".main-product .product__cart-cta");
    const ctaButtonLoader = ctaButton?.querySelector(".loading__spinner");

    let parentProductId = "";
    let parentProductName = "";
    let parentProductUrl = "";
    let parentProductCategory = "";
    let parentProductPrice = "";
    let parentProductQuantity = 0

    const quantityInput = this.querySelector('product-quantity input[type="number"]') as HTMLInputElement;
    const quantity = Number(quantityInput.value);

    try {
      const cta = event.currentTarget.parentElement;
      parentProductId = cta.getAttribute("data-bundle-product-id");
      parentProductName = cta.getAttribute("data-bundle-product-title");
      parentProductUrl = cta.getAttribute("data-bundle-product-url");
      parentProductCategory = cta.getAttribute("data-bundle-product-category");
      parentProductPrice = cta.getAttribute("data-bundle-product-price");
      parentProductQuantity = quantity;
    } catch {
      console.warn("Failed to fetch the product info from the parent of the CTA element.");
    }

    bundleProducts.forEach((product) => {
      const variantInput =
        (product.querySelector('product-variants input[type="radio"]:checked') as HTMLInputElement) ||
        (product.querySelector('.product__no-variants input[type="radio"]:checked') as HTMLInputElement);
      const itemKey = variantInput.value;
      console.log(product);

      const now = new Date();
      const uniqueId = `${bundleProducts.length}--${now.getTime()}-${now.toISOString().slice(0, 9)}`;

      productsArr.push({
        id: itemKey,
        quantity: quantity,
        properties: {
          bundle: parentProductName || "",
          _bundleMatcher: uniqueId,
          _bundleId: parentProductId || "",
          _bundleCategory: parentProductCategory || "",
          _bundlePrice: parentProductPrice || "",
          _bundleQuantity: parentProductQuantity || "",
          //_bundleName: parentProductName || "",
          // "product bundle url": parentProductUrl || ''
        },
      });
    });

    const previewCart = new PreviewCart();

    previewCart
      .addItems(productsArr)
      .then((data: any) => {
        if (data.status && data.status >= 400) {
          previewCart.closePreviewCart();

          let message = "There was an issue adding this item to your cart.";
          if (typeof data.description === "string") {
            message = data.description;
          } else {
            if (typeof data.description === "object") {
              const keys = Object.keys(data.description);
              if (keys.length && data.description[keys[0]].length) {
                message = data.description[keys[0]][0];
              }
            }
          }

          previewCart.cartErrorHandling(this.querySelector(".product-form__error-message-wrapper"), message);
        } else {
          if (parentProductPrice) {
            parentProductPrice = (Number.parseFloat(parentProductPrice) / 100).toFixed(2);
          } else {
            parentProductPrice = "0.00"
          }
          try {
            window.dataLayer.push({
              event: "bundle_add_to_cart",
              name: parentProductName,
              product_id: parentProductId,
              category: parentProductCategory,
              price: parentProductPrice,
              quantity: quantity
            });
            console.log("Pushing to bundle_add_to_cart event");

          } catch {
            console.error("Failed to push product data to GA4 when adding blundle to cart")
          }

          // Hardcoded timeout - roughly determined by the time it takes for fastbundles to update the cart
          setTimeout(() => {
            previewCart.updateCartHTML();
          }, 2500);
        }
      })
      .catch((error) => {
        console.error("error", error);
      });
  }

  addProductToCart() {
    const variantInput =
      (this.querySelector('product-variants input[type="radio"]:checked') as HTMLInputElement) ||
      (this.querySelector('.product__no-variants input[type="radio"]:checked') as HTMLInputElement);

    const itemKey = variantInput?.value;
    const quantityInput = this.querySelector('product-quantity input[type="number"]') as HTMLInputElement;
    const quantity = Number(quantityInput.value);

    // Get gift card checkbox status
    const giftCardCheckbox = this.querySelector(
      'input[name="properties[__shopify_send_gift_card_to_recipient]"]'
    ) as HTMLInputElement;
    let properties = {};

    // If gift card checkbox is checked, collect all recipient form data
    if (giftCardCheckbox && giftCardCheckbox.checked) {
      const recipientEmail = this.querySelector('input[name="properties[Recipient email]"]') as HTMLInputElement;
      const recipientName = this.querySelector('input[name="properties[Recipient name]"]') as HTMLInputElement;
      const message = this.querySelector('textarea[name="properties[Message]"]') as HTMLInputElement;
      const sendDate = this.querySelector('input[name="properties[Send on]"]') as HTMLInputElement;
      const timezoneOffset = this.querySelector('input[name="properties[__shopify_offset]"]') as HTMLInputElement;

      properties = {
        "Recipient email": recipientEmail?.value || "",
        "Recipient name": recipientName?.value || "",
        Message: message?.value || "",
        "Send on": sendDate?.value || "",
        __shopify_offset: timezoneOffset?.value || "",
        __shopify_send_gift_card_to_recipient: "on",
      };
    }

    const previewCart = new PreviewCart();

    previewCart
      .addItem(itemKey, quantity, properties)
      .then((data: any) => {
        if (data.status && data.status >= 400) {
          previewCart.closePreviewCart();

          let message = "There was an issue adding this item to your cart.";
          if (typeof data.description === "string") {
            message = data.description;
          } else {
            if (typeof data.description === "object") {
              const keys = Object.keys(data.description);
              if (keys.length && data.description[keys[0]].length) {
                message = data.description[keys[0]][0];
              }
            }
          }

          previewCart.cartErrorHandling(this.querySelector(".product-form__error-message-wrapper"), message);
        } else {
          previewCart.refreshPreviewCart(data);
        }
      })
      .catch((error) => {
        console.error("error", error);
      });
  }
}

customElements.define("main-product", Product);
